import React from 'react';
import PropTypes from 'prop-types';
import TweenOne from 'rc-tween-one';
import ScrollOverPack from 'rc-scroll-anim/lib/ScrollOverPack';
import { RightOutlined } from '@ant-design/icons';
import { Button, Row, Col } from 'antd';
import QueueAnim from 'rc-queue-anim';
export default function Page1({ isMobile }) {
  return (
    <ScrollOverPack id="page1" className="content-wrapper page">
      <Row justify='center'>
        <Col className='page-box' xs={20} sm={16} md={12} lg={11} xl={11}>
          <TweenOne
            key="image"
            className="image1 image-wrapper"
            animation={{ x: 0, opacity: 1, ease: 'easeOutQuad' }}
            style={{ transform: 'translateX(-100px)', opacity: 0 }}
          />
        </Col>
        <Col className='page-box' xs={20} sm={16} md={12} lg={11} xl={11}>
          <QueueAnim
            type={isMobile ? 'bottom' : 'right'}
            className="text-wrapper"
            key="text"
            leaveReverse
          >
            <h2 key="h2">领先的空气动力学技术与<br></br>卓越的升阻比</h2>
            <p key="p">
              我们的工程师应用了先进的空气动力学设计和大胆的工业设计，包括将飞机作为起落架固定的反向尾翼，这一设计可以平衡飞机重量，确保在最大载荷下也能稳定飞行；P系列的层流式机身将空气阻力降至最低，大幅提高了巡航速度，将升阻比提升至21（波音747客机升阻比为18）。</p>
          </QueueAnim>
        </Col>
      </Row>
    </ScrollOverPack>
  );
}
Page1.propTypes = {
  isMobile: PropTypes.bool,
};
